export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8688.35a0e738.jpg";